/**
 * FontAwesome: kun de ikoner vi rent faktisk bruger.
 *
 * Hele fas + far vejede 358 KB komprimeret (1,1 MB råt) og blev
 * modulepreloadet på hver eneste sidevisning. Samlet betød det cirka 560 KB
 * JavaScript før noget var interaktivt, og 73 % af vores brugere er på mobil.
 * Core Web Vitals er et rangeringssignal, så det kostede placeringer direkte.
 *
 * DET HER ER PRØVET FØR OG BLEV RULLET TILBAGE. Begrundelsen dengang:
 * "et manglende ikon fejler ikke pænt under SSR, det kaster 'Could not find one
 * or more icon(s)' og vælter hele server-renderingen (~900 SsrExceptions)", og
 * "der er DYNAMISKE :icon-bindinger hvis navne ikke kan kendes statisk".
 *
 * Den anden halvdel af begrundelsen holder ikke ved et nærmere kig:
 *
 *   AdminTable emptyIcon er 'bi-inbox'. Det er Bootstrap Icons og renderes som
 *   <i class="bi ...">, altså slet ikke FontAwesome.
 *
 *   AddToListButton og LinkCopyButton bruger ternærer, men mellem to KENDTE
 *   navne. De er talt med nedenfor.
 *
 * Den første halvdel holder, og derfor er der en test:
 * tests/Feature/IkonDaekningTest gennemgår hver .vue-fil, finder alle
 * ikon-navne og fejler hvis ét af dem ikke står her. Et nyt ikon kan altså
 * ikke vælte SSR uden at testen siger fra først.
 */
import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faAngleRight,
    faCartShopping,
    faCheck,
    faCheckCircle,
    faChevronDown,
    faCircleCheck,
    faCircleXmark,
    faLink,
    faList,
    faPlus,
    faPrint,
    faScaleBalanced,
    faShareNodes,
    faShop,
    faStar,
    faXmark,
} from '@fortawesome/free-solid-svg-icons';
import { faCircleCheck as farCircleCheck } from '@fortawesome/free-regular-svg-icons';

library.add(
    faAngleRight,
    faCartShopping,
    faCheck,
    faCheckCircle,
    faChevronDown,
    faCircleCheck,
    faCircleXmark,
    faLink,
    faList,
    faPlus,
    faPrint,
    faScaleBalanced,
    faShareNodes,
    faShop,
    faStar,
    faXmark,
    farCircleCheck,
);
